import { render, staticRenderFns } from "./index.vue?vue&type=template&id=46e5e997&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=46e5e997&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e5e997",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46e5e997')) {
      api.createRecord('46e5e997', component.options)
    } else {
      api.reload('46e5e997', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=46e5e997&scoped=true", function () {
      api.rerender('46e5e997', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplierManagement/vendorRole/index.vue"
export default component.exports